import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
import DeviceDetails from "./DeviceDetails";
import history from "../../auth/history";
import { store } from "../../redux/store";
import { resetMiscData, setAepsShow, setBankLogoList, setBillPayShow, setClaimLoadShow, setClientRole, setDeviceInfo, setDMTShow, setKycShow, setLoginTimestamp, setLogoName, setMenuVal, setMiscCallBackUrl, setPartner, setPayoutShow, setRechargeShow, setRequesterId, setRetailerBlanceShow, setTaLoadPermission, setTimeoutModal } from "../../redux/misc-data/misc-data.action";
import { setToken } from './../../redux/misc-data/misc-data.action';
import { setAgentInfo } from './../../redux/misc-data/misc-data.action';
import { setCallBackUrl } from "../../redux/auth/auth.action";
import { resetBillPayData } from "../../redux/billpayDetails/billpay.action";
import { resetAeps, setAepsSection } from "../../redux/aeps/aeps.action";
import { resetRecharge } from "../../redux/recharge/recharge.action";
import { resetRetailerKyc, setROId } from "../../redux/retailer-kyc-details/retailer-kyc-details.action";
import tokenErrorHandler from "../tokenErrorHandler";
import { resetOrderId } from "../../redux/order-details/order-details.action";
import { resetPayoutType } from "../../redux/payout/payout.action";
import menuShow from "../MenuComponent/menuShow";

const httpClient = axios.create();
class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            password: '',
            otpRef: '',
            message: ''
        }
    }

    componentDidMount() {



        store.dispatch(resetMiscData);
        store.dispatch(resetBillPayData);
        store.dispatch(resetRecharge);
        store.dispatch(resetRetailerKyc);
        store.dispatch(resetAeps);
        store.dispatch(resetOrderId);
        store.dispatch(resetPayoutType);

        localStorage.clear();

        this.loginFunction('0.00', '0.00');

        // setTimeout(() => {
        //     if (navigator.geolocation) {
        //         navigator.geolocation.getCurrentPosition(this.showPosition, this.posError);

        //     } else {

        //         this.loginFunction('0.00', '0.00');
        //     }
        // }, 300);



    }


    componentWillUnmount() {
    }


    showPosition = (position) => {
        let lat = position.coords.latitude;
        let long = position.coords.longitude;
        this.loginFunction(lat, long);
    }

    posError = () => {
        if (navigator.permissions) { }
        else { }
        this.loginFunction('0.00', '0.00');
    }

    loginFunction = (lat, lan) => {

        var query = window.location.search.substring(1);

        query = query.replace("/whitelabel", "");
        query = query.replace("/login", "");

        var emitraUrl = query.split("?")[0];
        var emitraParameters = query.split("?")[0];

        var vars = emitraParameters.split("&");
        console.log(vars);

        var encData = "";
        var partner = "";
        var service = '';
        var showall = '';

        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            console.log("pair: " + pair);
            if (pair[0] == "encData" || pair[0] == "encdata") {
                encData = pair[1];
            }
            console.log("encData=" + encData);
            if (pair[0] == "partner" || pair[0] == "partner") {
                partner = pair[1];
            }
            console.log("partner=" + partner);
            if (pair[0] == "service" || pair[0] == "service") {
                service = pair[1];
            }
            if (pair[0] == "showall" || pair[0] == "showall") {
                showall = pair[1];
            }
            console.log("service=" + service);
        }


        var requesterId = '';
        var logo = '';
        var role = '';
        var taLoad = '';
        var timeoutModal = '';
        var showBillPayMenu = '';
        var showRecharge = '';
        var showPayout = '';
        var showAepsMenu = '';
        var showDMT = '';
        var showKyc = '';


        var partners = process.env.REACT_APP_PARTNER;
        var requesterIds = process.env.REACT_APP_REQUESTERID;
        var logos = process.env.REACT_APP_LOGO;
        var roles = process.env.REACT_APP_ROLE;
        var timeoutModals = process.env.REACT_APP_TIMEOUT_MODAL;


        var partnerList = partners.split(',');
        var requesterIdList = requesterIds.split(',');
        var logoList = logos.split(',');
        var roleList = roles.split(',');
        var timeoutModalList = timeoutModals.split(',');


        var indexVal = 0;


        requesterId = requesterIdList[indexVal];
        logo = logoList[indexVal];
        role = roleList[indexVal];
        timeoutModal = timeoutModalList[indexVal];
        



        var menus = menuShow.getMenu();
        if (showall == 'false') {
            if (service == '') {
                if (menus.dmtShow == "yes") {
                    store.dispatch(setDMTShow("yes"));
                } else {
                    history.push('/403');
                    history.go();
                }
            }
            if (service == 'dmt') {
                if (menus.dmtShow == "yes") {
                    store.dispatch(setDMTShow("yes"));
                } else {

                    history.push('/403');
                    history.go();
                }
            }
            if (service == 'mobile' || service == 'recharge'||service == 'dth') {
                if (menus.rechargeShow == "yes") {
                    store.dispatch(setRechargeShow("yes"));
                } else {
                    history.push('/403');
                    history.go();
                }
            }
            if (service == 'billpay') {
                if (menus.billPayShow == "yes") {
                    store.dispatch(setBillPayShow("yes"));
                } else {
                    history.push('/403');
                    history.go();
                }
            }

            store.dispatch(setMenuVal('false:' + service))
        } else {

            store.dispatch(setDMTShow(menus.dmtShow))
            store.dispatch(setBillPayShow(menus.billPayShow))
            store.dispatch(setRechargeShow(menus.rechargeShow))
            store.dispatch(setMenuVal('true:all'))
        }


        const requestHeader = {
            msgType: "AUTHORIZE_WHITELABEL_USER",
            service: "EMITRA",
            src: "login",
            dst: "dashboard",
            channel: "WHITELABEL",
            requesterId: 'A0822450215EM',
            requestId: uuidv4(),//filled by the 3rd party requester
            time: moment().utc(),
            traceId: uuidv4(),
        }

        var authorizeRequest = "";


        const deviceInfo = DeviceDetails.fetchDeviceInfo(lat,
            lan);

        deviceInfo.then((deviceResponse) => {
            store.dispatch(setDeviceInfo(deviceResponse));

            var partnerIdVal = process.env.REACT_APP_PARTNER_ID_ + partner;
            if (partnerIdVal.includes("undefined")) {
                partnerIdVal = partnerIdVal.substring(9);
            }

            console.log("partnerIdVal", partnerIdVal);

            authorizeRequest = {
                header: requestHeader,
                device: deviceResponse,
                encData: encData

            }


            console.log('request::' + JSON.stringify(authorizeRequest));

            var url = '/api/v1/emitra/user/auth';

            httpClient.post(url, authorizeRequest
            ).then((response) => {
                console.log('login response' + JSON.stringify(response.data));

                if (response.data.response.msg == 'SUCCESS') {

                    console.log('login time:', moment().format("DD-MM-YYYY hh:mm:ss"));

                    var token = response.data.token;

                    store.dispatch(setToken(token));
                    store.dispatch(setAgentInfo(response.data.agent));
                    store.dispatch(setRequesterId(requesterId));
                    store.dispatch(setLogoName(logo));
                    store.dispatch(setPartner(partner));
                    store.dispatch(setClientRole(role));
                    store.dispatch(setTimeoutModal(timeoutModal));
                    // store.dispatch(setBillPayShow(showBillPayMenu));
                    // store.dispatch(setRechargeShow(showRecharge));
                    // store.dispatch(setPayoutShow(showPayout));
                    // store.dispatch(setAepsShow(showAepsMenu));
                    // store.dispatch(setDMTShow(showDMT));
                    // store.dispatch(setKycShow(showKyc));
                    store.dispatch(setROId(response.data.agent.internalRoId));
                    store.dispatch(setLoginTimestamp(new Date()));

                    if (response.data.redirectUrl != undefined &&
                        response.data.redirectUrl != null &&
                        response.data.redirectUrl != '') {
                        store.dispatch(setCallBackUrl(response.data.redirectUrl));
                        store.dispatch(setMiscCallBackUrl(response.data.redirectUrl))
                    }


                    var interVal = setInterval(() => {
                        if (this.props.agentInfo != undefined &&
                            this.props.agentInfo != null &&
                            this.props.agentInfo != '' &&

                            this.props.token != undefined &&
                            this.props.token != null &&
                            this.props.token != '' &&

                            this.props.clientRole != undefined &&
                            this.props.clientRole != null &&
                            this.props.clientRole != '' &&

                            this.props.clientRequesterId != undefined &&
                            this.props.clientRequesterId != null &&
                            this.props.clientRequesterId != '') {
                            console.log('data...' + this.props.agentInfo + ":" + this.props.clientRole + ":" + this.props.token);
                            clearInterval(interVal);
                            if (service == '') {
                                history.push('/dmt');
                                history.go();
                            }
                            if (service == 'dmt') {
                                history.push('/dmt');
                                history.go();
                            }
                            if (service == 'mobile'
                                || service == 'recharge') {
                                history.push('/recharge');
                                history.go();
                            }
                            if (service == 'recharge'
                                || service == 'recharge') {
                                history.push('/recharge');
                                history.go();
                            }
                            if (service == 'dth'
                                || service == 'recharge') {
                                history.push('/recharge');
                                history.go();
                            }
                            if (service == 'billpay') {
                                history.push('/billpay');
                                history.go();
                            }
                            if (service == 'aeps') {
                                history.push('/aeps');
                                history.go();
                            }
                            if (service == 'payout') {
                                history.push('/merchant-payout');
                                history.go();
                            }
                        } else {
                            console.log('data...' + this.props.agentInfo + ":" + this.props.clientRole + ":" + this.props.token);
                        }

                    }, 1500);

                } else {
                    history.push('/403');
                    history.go();
                }
            }).catch(error => {
                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                } else {
                    history.push('/403');
                    history.go();
                }
                console.log(error.message);
            });
        })
    }

    render() {

        return (

            <div></div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { otpRefNo, phone, callBackUrl, agentInfo, token, clientRole, clientRequesterId } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, otpRefNo, phone, callBackUrl, agentInfo, token, clientRole, clientRequesterId
});

export default connect(mapStateToProps, null)(Login);
